import { IconButton, Tooltip } from '@mui/material';
import { X } from '@phosphor-icons/react';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../../../hooks/global/typedReduxHooks';
import investigatorNotesServices from '../../../../../../../services/investigatorNotes';
import {
  removeInvestigatorNoteCategory,
  setInvestigatorNoteCategoriesAsActive,
} from '../../../../../../../slices/reportSlice';
import ScrollableRow from '../../../../../../common/scrollableRow';

import { Button } from '~/components/ui/button';

const InternalCommentsCategories = () => {
  const intl = useIntl();
  const investigatorNoteCategories = useAppSelector(
    (state) => state.reports.investigatorNoteCategories,
  );
  const dispatch = useAppDispatch();

  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-row'>
        <h5 className='text-xs font-semibold text-gray-600 leading-3'>
          <FormattedMessage defaultMessage='Categories' />
        </h5>
      </div>
      <div className='flex flex-row justify-center'>
        <ScrollableRow>
          {investigatorNoteCategories.map((category) => (
            <Button
              variant='soft'
              color={category.selected ? 'primary' : 'neutral'}
              key={category.id}
              onClick={() => {
                dispatch(
                  setInvestigatorNoteCategoriesAsActive({
                    ...category,
                    selected: !category.selected,
                  }),
                );
              }}
              endDecorator={
                <div>
                  <Tooltip
                    title={intl.formatMessage({
                      defaultMessage: 'Delete category',
                    })}
                    placement='top'
                  >
                    <IconButton
                      size='small'
                      onClick={(
                        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
                      ) => {
                        event.stopPropagation();
                        investigatorNotesServices.deleteNoteCategory(
                          category.id,
                        );
                        dispatch(removeInvestigatorNoteCategory(category.id));
                      }}
                    >
                      <X />
                    </IconButton>
                  </Tooltip>
                </div>
              }
            >
              {category.name}
            </Button>
          ))}
          {isEmpty(investigatorNoteCategories) && (
            <p className='text-gray-500 text-sm font-normal leading-3 py-2'>
              <FormattedMessage defaultMessage='No categories yet' />
            </p>
          )}
        </ScrollableRow>
      </div>
    </div>
  );
};

export default InternalCommentsCategories;
